import { getDossierChartData } from "../../../../api/dossier/getDossierChartData";
import { DossierBudgetsDatum } from "../../../../types/Chart";
import { CRMAppLocationIdentifier, FaqProps } from "../../../../types/Faq";
import APChart from "../APChart";
import DossierBudgetTotals from "./DossierBudgetTotals";

const DossierBudgetsChart = ({
  dossierId,
  showTotals,
  faqs,
  faqAppLocationIdentifiers,
}: {
  dossierId: string;
  showTotals: boolean;
  faqs: FaqProps;
  faqAppLocationIdentifiers: {
    category: CRMAppLocationIdentifier;
    availableBudget: CRMAppLocationIdentifier;
  };
}) => {
  const { data, isSuccess } = getDossierChartData<DossierBudgetsDatum>(
    dossierId,
    "dossier-budgets"
  );

  return (
    <APChart
      key={dossierId}
      type="line"
      getData={() =>
        getDossierChartData<DossierBudgetsDatum>(dossierId, "dossier-budgets")
      }
      xAxisOptions={{ type: "time" }}
      yAxisOptions={{ type: "currency" }}
      dimensions={[
        { key: "date", label: "Date" },
        { key: "fuel", label: "Fuel / Charging" },
        { key: "servicing", label: "Service" },
        { key: "tyres", label: "Tyres" },
        { key: "insurance", label: "Insurance" },
        { key: "rego", label: "Rego / CTP" },
      ]}
      totalsRenderer={
        showTotals
          ? () => (
              <DossierBudgetTotals
                dossierId={dossierId}
                fuel={
                  isSuccess ? data?.[data.length - 1]?.fuel || 0 : undefined
                }
                servicing={
                  isSuccess
                    ? data?.[data.length - 1]?.servicing || 0
                    : undefined
                }
                tyres={
                  isSuccess ? data?.[data.length - 1]?.tyres || 0 : undefined
                }
                insurance={
                  isSuccess
                    ? data?.[data.length - 1]?.insurance || 0
                    : undefined
                }
                rego={
                  isSuccess ? data?.[data.length - 1]?.rego || 0 : undefined
                }
                faqs={faqs}
                faqAppLocationIdentifiers={faqAppLocationIdentifiers}
              />
            )
          : undefined
      }
    />
  );
};

export default DossierBudgetsChart;
